import { Grid, Link, ListItem, ListItemIcon, Typography, makeStyles } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import { Flaticon } from "../../components";

const useStyles = makeStyles(() => ({
  textFormatted: {
    whiteSpace: "pre-line"
  }
}));

const CompanyProfileTab = ({ exhibitor }) => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={7}>
        <Typography variant="body2" className={classes.textFormatted}>
          {exhibitor.profileDescription}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={5}>
        <ListItem>
          <ListItemIcon>
            <Flaticon icon="contact-book" fontSize="1.5rem" />
          </ListItemIcon>
          <Typography variant="body1">
            <strong>
              {intl.formatMessage({
                id: "ExhibitorPage.CompanyProfileTab.Contacts",
                defaultMessage: "Contacts"
              })}
            </strong>
          </Typography>
        </ListItem>
        <ListItem>
          <ListItemIcon />
          <Typography variant="body2">
            {exhibitor.profileAddress}
            <br />
            {exhibitor.profilePhone}
            <br />
            <Link href={`mailto: ${exhibitor.profileEmail}`}>{exhibitor.profileEmail}</Link>
          </Typography>
        </ListItem>
      </Grid>
    </Grid>
  );
};

export default CompanyProfileTab;
